/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Percent_VarianceInputs */

const en_audit_percent_variance = /** @type {(inputs: Audit_Percent_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% Variance`)
};

const es_audit_percent_variance = /** @type {(inputs: Audit_Percent_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% Variacion`)
};

/**
* | output |
* | --- |
* | "% Variance" |
*
* @param {Audit_Percent_VarianceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_percent_variance = /** @type {((inputs?: Audit_Percent_VarianceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Percent_VarianceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_percent_variance(inputs)
	return es_audit_percent_variance(inputs)
});